import { render, staticRenderFns } from "./Setoran.vue?vue&type=template&id=56219600"
import script from "./Setoran.vue?vue&type=script&lang=js"
export * from "./Setoran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports